import './Links.css'
import EditableLinks from '../../../Components/EditableLinks/EditableLinks'

const Links = () => {
  return (
    <div className='links-sections'>
      <EditableLinks />
    </div>
  )
}

export default Links
